import React from 'react';	
import PreLoginPage from './PreLoginPage';
import '../../css/errorPage.css';

export default class ErrorPage extends PreLoginPage{

	constructor(props){
		super(props);

		this.lastAccessedView = "lastAccessedView";
	}
	
	componentDidMount(){
		try{
			var errPath = document.location.pathname;	
			if(errPath !== null && errPath.length > 1){
				errPath = errPath.replace("/","");
				document.title +=  " " + errPath + " ";
			}else{
				document.title += " 404 ";
			}
		}catch(e){
			document.title += " 404 ";
		}

		this.removeLastViewedIfNotAvailable();
	}

	/**
	* REMOVE IF IT CAUSES -ve Impact. This will remove lastViewed if the route is not longer available
	* and due to which it led to 404
	*/
	removeLastViewedIfNotAvailable(){
		let me = this;
		try{
			let savedUri = this.getLastAccessedView();
			if(window.document.referrer && savedUri){
				let refererUri = window.document.referrer.replace(/(http(s)?:\/\/)?(.*)(.com)(:)?([0-9]+)?/g,"")

				if(savedUri.trim() === refererUri.trim()){
					me.removeAttribute(me.lastAccessedView);
				}
			}
		}catch(e){
			console.error(e);
		}		
	}

	render(){
		return(
			<div className="errorContainer">
			<div className="errorback text-center">
			<div className="fff">
			<div>
			<div > <span className="f100 robotto fwb" >404</span></div><br/>
			<div ><span className="f40 fwb">Oops.</span></div><br/>
			<div ><span className="f30">You seem to be lost.</span></div><br/>
			<div className="f30"><span>Let&#39;s get you back <a href="/" className="r-btn errHome">Home</a> </span></div>
			</div>
			</div>
			</div>
			</div>

			);
		}
	}


// WEBPACK FOOTER //
// ./src/views/core/ErrorPage.js